import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Button } from '@material-ui/core'
import { aiBackgroundGradient } from 'app/configs/aiBackgroundConfigs'
import StarPlatinum from 'app/components/icons/StarPlatinum'

const DiscoveryNewAI = (props) => {
  const { onClickStartTour } = props
  return (
    <div className="flex flex-col">
      <div className="flex flex-row mb-4">
        <span className="font-bold text-blue-950 text-16">
          <FormattedMessage id="discoverNew.title" />
        </span>
        <StarPlatinum className="px-2" width={12} height={12}></StarPlatinum>
      </div>
      <div className="flex flex-col bg-primary-200 p-12 mb-4">
        <div
          style={aiBackgroundGradient}
          className="flex flex-row py-12 text-white text-12 rounded-lg justify-center items-center"
        >
          <StarPlatinum className="px-2" width={22} height={22}></StarPlatinum>
          <span className="ml-8">
            <FormattedMessage id="discoverNew.titleAI" />
          </span>
        </div>
        <span className="my-12">
          <FormattedMessage id="discoverNew.body" />
        </span>
        <div className="flex flex-row justify-between items-center">
          <span className="font-bold">
            <FormattedMessage id="discoverNew.letGetStarted" />
          </span>
          <Button
            variant="contained"
            size="small"
            className="h-36 capitalize text-14 font-medium bg-secondary"
            onClick={() => onClickStartTour()}
          >
            <FormattedMessage id="startTour" />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default React.memo(DiscoveryNewAI)
